// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import PropertyTaxRateInput from '../property-tax-rate';

const PropertyTaxRateInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <PropertyTaxRateInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default PropertyTaxRateInputWithAnalytics;
